import React from 'react'
import { motion } from 'framer-motion/dist/framer-motion'

const Waves = React.forwardRef((props, ref) => {
    const drawWave = (color) => {
        return {
            hidden: () => { 
                return {
                    pathLength: 0,
                    fill: '#FFFFFF',
                    fillOpacity: 0,
                    stroke: '#FFFFFF',
                    opacity: 0
                }
            },
            visible: (i) => {
                let stroke = color
                const strokeDelay = i * 0.5
                const fillDelay = strokeDelay + 0.25
                const transition = {
                    pathLength: { delay: strokeDelay, duration: 2, ease: "easeInOut" },
                    opacity: { delay: strokeDelay, duration: 0.1 },
                    fillOpacity: { delay: fillDelay, duration: 1.5, ease: "easeInOut"},
                    fill: { delay: fillDelay, duration: 1.5, ease: "easeInOut"},
                }
                return {
                    pathLength: 1.1,
                    fill: color,
                    fillOpacity: 1,
                    stroke,
                    opacity: 1,
                    pathOffset: 0,
                    transition,
                }
            },
        }
    }
    
    return (
        <motion.svg
            ref={ref}
            className="mga-page-bg"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 282 1250"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.1 }}
            style={{
                fillRule: "evenodd", 
                clipRule: "evenodd", 
                strokeLinejoin: "round", 
                strokeMiterlimit: 2,
                strokeWidth: 0.2
            }}
        >
            <g transform="translate(341 3525)">
                <motion.path
                    d="M1023.43,55.946H876.465c-109-324.912-178.676-617.258-105.231-1250h252.2v1250"
                    stroke="#ef7d10"
                    fill="#FFFFFF"
                    variants={drawWave("#ef7d10")}
                    initial="hidden"
                    animate="visible"
                    custom={0}
                    transform="translate(-1081.91 -2330.946)"
                    style={{
                        fillRule: "nonzero",
                    }}
                />
                <motion.path
                    d="M929.769,255.18c-124.428-826.95,115.181-1185,115.181-1185v1185"
                    stroke="#e23b00"
                    fill="#FFFFFF"
                    variants={drawWave("#e23b00")}
                    initial="hidden"
                    animate="visible"
                    custom={2}
                    transform="translate(-1103.426 -2530.18)"
                    style={{
                        fillRule: "nonzero",
                    }}
                />
            </g>
        </motion.svg>
    )
})

export default React.memo(Waves)